import React, { useState } from 'react';

import '../../styles/content-grid.scss';

import { useSelector } from 'react-redux';

import ThreeDotsLoader from '../../../../common-components/Loaders/ThreeDotsLoader';
import OutlinedButton from '../../../../styledComponents/OutlinedButton.style';
import ContentCard from '../ContentCard';
import GetSocialListeningModal from '../modals/GetSocialListeningModal';
import { useCampaignDetail } from './CampaignDetailProvider';
import ContentGridBlocker from './ContentGridBlocker';
import ContentGridSkeleton from './ContentGridSkeleton';
import LabellingModal from './Labelling/LabellingModal';
import NoContent from './NoContent';
import NoPostAvailable from './NoPostAvailable';

const ContentGridSection = () => {
  const { content, isTrackingInProgress, loadingContent, isNextContent, onLoadMoreClick, isLoadingMore } =
    useCampaignDetail();

  const [getAddOnModalOpen, setGetAddOnModalOpen] = useState(0);

  const { userSettings } = useSelector((s) => s.user);

  const isPostTrackingAddOnBought = Boolean(userSettings?.postTrackingStatus);

  const isBlockedContent = (rowIndex, colIndex) => {
    return !isPostTrackingAddOnBought && ((rowIndex > 1 && colIndex > 1) || colIndex > 2);
  };

  if (loadingContent) {
    return <ContentGridSkeleton />;
  }

  if (isTrackingInProgress && !loadingContent) {
    return <NoPostAvailable />;
  }

  if (content.posts.length === 0) return <NoContent />;
  return (
    <>
      <GetSocialListeningModal currentOpenModal={getAddOnModalOpen} setCurrentModal={setGetAddOnModalOpen} />
      <div className="masonary-grid">
        {content.posts.map((post) => (
          <ContentCard key={post._id} post={post} />
        ))}
      </div>
      {isNextContent.isNext && (
        <div className="sl-load-more-container">
          <OutlinedButton onClick={() => onLoadMoreClick()}>
            {isLoadingMore && <ThreeDotsLoader color="#7F38E9" />}
            See Older Posts…
          </OutlinedButton>
        </div>
      )}
    </>
  );
};

export default ContentGridSection;
